import dotProp from 'dot-prop-immutable';

import {
  HYDRATE_BUSINESSES,
  SET_BUSINESS_ACCOUNT_STATUS,
  SET_EXPERT_RANKS,
  SET_MINIMUM_EXPERT_RANK,
  SET_EXTRA_BUSINESS_INFO,
  SET_BUSINESS_SIMPLR_CATEGORIES,
  SET_SUBBUSINESS_VERTICALS,
  SET_USE_MENU_OPERATOR,
  SET_SEARCH_PARAMS_BUSINESSES_DETAILS,
  UPDATE_BUSINESS_SPAM_FILTER,
  UPDATE_BUSINESS_TAGS_MAP,
  HYDRATE_BUSINESSES_DETAILS_LIST,
  HYDRATE_BUSINESSES_DETAILS_PAGE,
  SET_DECISION_TREE,
  SET_DECISION_TREE_DRAFTS,
  SET_PARTNER_INFO,
  SET_BRAND_OPTIONS,
  SET_TAGS_CONFIG,
  SET_FLOW_DEBUG_STATE_FAVORITE_FIELDS_LIST,
} from '../actions/types';

const updateBusinessLens = (businessState, simplrBusinessId, attributes) => {
  return {
    ...businessState,
    all: {
      ...businessState.all,
      [simplrBusinessId]: {
        ...(businessState.all[simplrBusinessId] || {}),
        ...attributes,
      },
    },
  };
};

export const initialState = {
  all: {},
  pagination: {
    page: 0,
    idList: [],
    selectedBrandOptions: [],
    searchParam: '',
    businessStatuses: [],
    loadLimit: 100,
    full: false,
    cursor: null,
  },
};

const businesses = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BUSINESS_SPAM_FILTER:
      return updateBusinessLens(state, action.simplrBusinessId, { [action.field]: action.list });
    case SET_EXTRA_BUSINESS_INFO:
      return updateBusinessLens(state, action.simplrAccountId, { extraBusinessInfo: { ...action.extraBusinessInfo } });
    case SET_PARTNER_INFO:
      return dotProp.set(state, `all.${action.simplrAccountId}.partnerInfo`, action.partnerInfo);
    case SET_TAGS_CONFIG:
      return dotProp.set(state, `all.${action.simplrAccountId}.tagsConfig`, action.tagsConfig);
    case SET_BRAND_OPTIONS:
      return dotProp.set(state, `all.${action.simplrAccountId}.brandOptions`, action.brandOptions);
    case SET_EXPERT_RANKS:
      return updateBusinessLens(state, action.simplrBusinessId, { expertRanks: action.expertRanks });
    case SET_MINIMUM_EXPERT_RANK: // depricated
      return updateBusinessLens(state, action.simplrBusinessId, { minimumExpertRank: action.rank });
    case SET_BUSINESS_ACCOUNT_STATUS:
      return updateBusinessLens(state, action.simplrAccountId, { accountStatus: action.accountStatus });
    case HYDRATE_BUSINESSES:
      return dotProp.set(state, 'all', action.accountIdsToBusinesses);
    case SET_BUSINESS_SIMPLR_CATEGORIES:
      return dotProp.set(state, `all.${action.simplrAccountId}.simplrCategories`, action.simplrCategories);
    case SET_DECISION_TREE:
      return dotProp.set(state, `all.${action.simplrAccountId}.decisionTree`, action.decisionTree);
    case SET_DECISION_TREE_DRAFTS:
      return dotProp.set(state, `all.${action.simplrAccountId}.decisionTreeDrafts`, action.decisionTreeDrafts);
    case SET_USE_MENU_OPERATOR:
      return dotProp.set(state, `all.${action.simplrAccountId}.useMenuOperator`, action.status);
    case SET_SUBBUSINESS_VERTICALS:
      return dotProp.set(state, `all.${action.simplrAccountId}.subBusinessVerticals`, action.subBusinessVerticals);
    case UPDATE_BUSINESS_TAGS_MAP:
      return updateBusinessLens(state, action.selectedBusinessId, {
        simplrCategories: {
          ...state.all[action.selectedBusinessId].simplrCategories,
          simplrPartnerTagsMap: action.updatedMap,
        },
      });
    case SET_SEARCH_PARAMS_BUSINESSES_DETAILS: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          searchParam: action.searchParam,
          businessStatuses: action.businessStatuses,
          page: 0,
          idList: [],
          selectedBrandOptions: [],
          full: false,
          cursor: null,
        },
      };
    }
    case HYDRATE_BUSINESSES_DETAILS_PAGE: {
      return {
        ...state,
        all: {
          ...state.all,
          ...action.payload.businessDetails.reduce((acc, item) => {
            acc[item.id] = item;

            return acc;
          }, {}),
        },
        pagination: {
          ...state.pagination,
          idList: [...state.pagination.idList, ...action.payload.businessDetails.map((item) => item.id)],
          page: state.pagination.page + 1,
          full: action.payload.businessDetails.length !== state.pagination.loadLimit,
          cursor: action.payload.cursor,
        },
      };
    }
    case HYDRATE_BUSINESSES_DETAILS_LIST: {
      const { payload } = action;

      return {
        ...state,
        all: {
          ...state.all,
          ...payload.reduce((acc, item) => {
            acc[item.id] = item;

            return acc;
          }, {}),
        },
      };
    }
    case SET_FLOW_DEBUG_STATE_FAVORITE_FIELDS_LIST:
      return dotProp.set(
        state,
        `all.${action.simplrAccountId}.flowDebugStateFavoriteFieldsList`,
        action.flowDebugStateFavoriteFieldsList
      );
    default:
      return state;
  }
};

export default businesses;
